<div *ngIf="!inlineAddRow && addNewRow" class="d-flex justify-content-end">
  <button *ngIf="!customButton || addNewRowButton" (click)="addRow($event)" class="btn btn-continue-bordered-bd">{{'CONFIGURE.ADD_NEW' | translate}}</button>
  <button *ngIf="customButton" class="{{ customButton.customClass ? customButton.customClass : 'ml-4 btn btn-continue-bordered-bd k-button k-grid-add-command float-right' }}"
    [ngClass]="{'k-state-appear-disabled': !customButton.isActive}"
    (click)="customButton ? customButton.onClick() : return"><img src="assets/icons/addOutline.svg" class="pr-1" *ngIf="customButton.addImage"> {{customButton.buttonText | translate }}</button>
  <button *ngIf="migrationButton"
    class="ml-4 btn btn-continue-bordered-bd k-button k-grid-add-command float-right map-btn"
    [ngClass]="{'k-state-appear-disabled': !migrationButton.isActive}"
    (click)="migrationButton ? migrationButton.onClick() : return">{{migrationButton.buttonText | translate }}</button>
</div>
<div #container class="bd-light-table-container" [ngClass]="(!gridData || gridData.length == 0) ? 'no-data-found' : ''">
  <table mat-table [dataSource]="dataSource" class="bd-light-table" [style.margin-top]="hasSubtitles ? '50px' : 0"
    [ngClass]="classTable ? classTable : ''">

    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef class="select-cell">
        <div class="th-span" (click)="toggleMasterSelection()">
          <img class="checkbox" *ngIf="isAllSelected()" src="assets/icons/checkbox-checked.svg">
          <img class="checkbox" *ngIf="!isAllSelected()" src="assets/icons/checkbox-unchecked.svg">
        </div>
      </th>
      <td mat-cell *matCellDef="let row" class="select-cell">
        <div (click)="toggleIndividualSelection(row)">
          <img class="checkbox" *ngIf="selection.isSelected(row)" src="assets/icons/checkbox-checked.svg">
          <img class="checkbox" *ngIf="!selection.isSelected(row)" src="assets/icons/checkbox-unchecked.svg">
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="{{field.field}}"
      *ngFor="let field of fields; let rowIndex = index; trackBy: trackDataSource">
      <th mat-header-cell *matHeaderCellDef [ngClass]="field.class ? field.class : ''">
        <span class="th-span" *ngIf="!field.subtitle">{{field.title | translate}}</span>
        <div class="custom-tooltip"> <span class="th-span" *ngIf="field.subtitle"> {{field.title | translate}} </span>
          <span class="tooltip-text">{{ field.subtitle | translate }}</span>
        </div>
      </th>
      <td mat-cell *matCellDef="let cell; let i = index;" [ngClass]="field.class ? field.class : ''">
        <span
          *ngIf="!defaultColumnTable && (editRowIndex != i || !field.editTemplate || editRowIndex == i && (field.editTemplate.isDisabled && field.editTemplate.isDisabled(cell)))"
          [ngClass]="{'emptyZero':zeroIfEmpty,'emptyNA':NAifEmpty}">{{ cell[field.field] | translate}}</span>
        <div class="edit-div"
          *ngIf="!defaultColumnTable && editRowIndex == i && field.editTemplate && (!field.editTemplate.isDisabled || (field.editTemplate.isDisabled && !field.editTemplate.isDisabled(cell)))">
          <input class="text-input" *ngIf="field.editTemplate.type == 'text'" [(ngModel)]=" editItem[field.field]"
            [attr.maxlength]="!field.editTemplate.maxLength ? null : field.editTemplate.maxLength"
            (ngModelChange)="changeValue($event,  i , field.field, 'input')">
          <label *ngIf="field.editTemplate.type == 'checkbox'" class="switch">
            <input type="checkbox" class="form-control kendo-grid-form-control"
              placeholder="{{cell[field.field] | translate}}" [(ngModel)]="editItem[field.editTemplate.valueField]"
              [checked]="field.editTemplate.isChecked ? field.editTemplate.isChecked(cell) : false"
              (ngModelChange)="changeValue($event,  i , field.editTemplate.valueField, 'check')">
            <span class="slider round"></span>
            <span class="status active">{{(field.editTemplate.validText ? field.editTemplate.validText :
              'CONFIGURE.ENABLED') | translate}}</span>
            <span class="status inactive">{{(field.editTemplate.invalidText ? field.editTemplate.invalidText
              :"CONFIGURE.DISABLED") | translate }}</span>
          </label>

          <div class="select" *ngIf="field.editTemplate.type == 'dropdown'">
            <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
              <input class="dropdown-toggle" type="text"
                [ngModel]="layoutService.translateText(editItem[field.editTemplate.textField])" readonly />
              <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
            </div>
            <ul class="dropdown-menu">
              <li *ngFor="let option of field.editTemplate.data" [value]="option[field.editTemplate.valueField]"
                class="dropdown-item"
                (click)="changeValue(option[field.editTemplate.valueField],  i, field.editTemplate.valueField, 'dropdown', field.editTemplate.textField )">
                {{option[field.editTemplate.textField] | translate}}
              </li>
            </ul>
          </div>
        </div>

        <span *ngIf="defaultColumnTable && !field.editTemplate"
          [ngClass]="{'emptyZero':zeroIfEmpty,'emptyNA':NAifEmpty}">{{ cell[field.field] | translate}}</span>
        <div *ngIf="defaultColumnTable && field.editTemplate && field.editTemplate.type == 'radio'">
          <input type="radio" class="form-control kendo-grid-form-control"
            [(ngModel)]="defaultId" [value]="cell[field.editTemplate.valueField]"
            (ngModelChange)="changeValueRadio(cell[field.editTemplate.valueField])">
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions" *ngIf="hasActions && !defaultColumnTable" stickyEnd>
      <th mat-header-cell *matHeaderCellDef class="action" [ngClass]="classTable ? classTable : ''">
        <span class="th-span">{{'INSTITUTION_MANAGEMENT.ACTIONS' | translate}}</span>
      </th>
      <td mat-cell *matCellDef="let row; let rowIndex = index; let cellIndex = index;" class="action">
        <div *ngIf="editRowIndex != rowIndex" class="actions-div d-flex align-items-center justify-content-end">
          <button *ngIf="!editMode && (isRowEditable ? hasRowLink(row) : false)" (click)="brokeLink(row)"
            class="linkButton btn-edit-icon" title="{{ 'CONFIGURE.UNLINKWARD' | translate }}">
            <img src="assets/ph-bhp-layout/svg/link-off-blue.svg" title="{{ 'CONFIGURE.UNLINKWARD' | translate }}">
          </button>
          <div *ngFor="let item of actions">
            <!-- edit row button -->
            <ng-container *ngIf="showAction(item, row)">
              <button *ngIf="item.isEdit" mat-button class="btn-edit-icon" (click)="editRow($event, row, rowIndex);">
                <img class="actionIcon" src="{{item.imgSrc}}" title="{{item.name | translate}}" data-title="">
              </button>
              <!-- buttons defineds in parent -->
              <button *ngIf="!item.isEdit && (item.canShow? item.canShow(row, rowIndex) : true) && !item.isEnableAction"
                mat-button class="btn-edit-icon" (click)="item.onClick(row, rowIndex)">
                <img class="actionIcon" src="{{item.imgSrc}}" title="{{item.name | translate}}" data-title="">
              </button>
            </ng-container>
          </div>
        </div>
        <div *ngIf="editRowIndex == rowIndex" class="actions-div d-flex align-items-center justify-content-end">
          <button mat-button class="btn-edit-icon" (click)="saveRow($event, row, rowIndex)">
            <img class="actionIcon" src="assets/ph-bhp-layout/svg/icon-save.svg"
              title="{{'AUTHORIZATION.SAVE' | translate}}" data-title="">
          </button>
          <button mat-button class="btn-edit-icon cancel" (click)="cancel()">
            <img class="actionIcon" src="assets/ph-bhp-layout/svg/icon-cancel-blue.svg"
              title="{{'AUTHORIZATION.CANCEL' | translate}}" data-title="">
          </button>
        </div>
      </td>
    </ng-container>

    <!-- Default actions -->
    <ng-container matColumnDef="actions" *ngIf="hasActions && defaultColumnTable" stickyEnd>
      <th mat-header-cell *matHeaderCellDef class="action" [ngClass]="classTable ? classTable : ''">
        <span class="th-span">{{'INSTITUTION_MANAGEMENT.ACTIONS' | translate}}</span>
      </th>

      <td mat-cell *matCellDef="let row; let rowIndex = index; let cellIndex = index;" class="action">
        <div class="actions-div d-flex align-items-center"
          [ngClass]="isDefault(row.id) ? 'justify-content-start' : 'justify-content-end'">
          <div *ngFor="let item of actions">
            <ng-container>
              <button *ngIf="item.name != 'CHECK.CONFIGURE.DELETE' || !isDefault(row.id)"
                mat-button class="btn-edit-icon" (click)="item.onClick(row, rowIndex)">
                <img class="actionIcon" src="{{item.imgSrc}}" title="{{item.name | translate}}" data-title="">
              </button>
            </ng-container>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container *ngFor="let groupHeader of groupHeaders; let i = index" [matColumnDef]="groupHeader">
      <th mat-header-cell *matHeaderCellDef [attr.colspan]="columnGroups.get(groupHeader.replace('group-', ''))?.length"
        class="group-header" [class.first-group]="i === 0">
        <!-- render bug -->
        <!-- <span> {{ i === 0 ? (chartType != '' ? (chartType === 'filter' ? ('EVALUATION.FILTER' | translate) : ('DASHBOARD.BENCHMARK' | translate)) : '') : '' }} </span> -->
        {{ groupHeader.replace('group-', '') | translate }}
      </th>
    </ng-container>
    <ng-container *ngIf="columnGroups.size > 0">
      <tr mat-header-row *matHeaderRowDef="groupHeaders" class="filters-row"></tr>
    </ng-container>

    <ng-container *ngFor="let multiHeader of multiHeaders; let m = index" [matColumnDef]="multiHeader">
      <th mat-header-cell *matHeaderCellDef
        [attr.colspan]="multiColumnGroups.get(multiHeader.replace('multi-', ''))?.length" class="multi-header"
        [class.first-multi]="m === 0" #headerElement>
        <!-- NOTE: angular mix multifilter and filter rows and only render the second inner content  -->
        <!-- for this reason, the span needs a function for choose the text from parent class (filters-row or multi-row) -->
        <span> {{ getHeaderText(m, headerElement) | translate }} </span>
        {{ multiHeader.replace('multi-', '') | translate }}

      </th>
    </ng-container>
    <ng-container *ngIf="multiColumnGroups.size > 0">
      <tr mat-header-row *matHeaderRowDef="multiHeaders" class="multi-row"></tr>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="fieldsKeys"></tr>
    <tr mat-row *matRowDef="let row; columns: fieldsKeys; let rowIndex = index"
      [ngClass]="rowIndex == editRowIndex ? 'edit' : '' "></tr>
    <div mat-row class="nodata-row" *matNoDataRow>
      <div class="nodata-inner" *ngIf="!isEvaluationTable">{{ 'EVALUATION.NO_DATA_FOUND' | translate }}</div>
      <div class="no-data-text" *ngIf="isEvaluationTable">{{ 'CONFIGURE.FILTERS.NO_DATA_FOUND' | translate }}</div>
    </div>
  </table>
</div>

<div class="bd-paginator" *ngIf="showPaginator && gridData && gridData.length > 0">
  <div class="loadPagination" *ngIf="loading"><mat-icon>hourglass_empty</mat-icon></div>
  <div class="paginator-top">
    <div class="pageSize-selector d-flex align-items-center">
      <span class="paginator-title mr-4"> {{ pageInfo.itemsPerPageLabel | translate }}</span>
      <div class="dropdown dropdown-bhp mr-4">
        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
          <input class="dropdown-toggle-pages bg-grey" type="text" [ngModel]="pageSize | labelSanitizer" readonly />
          <img class="dropdown-arrow-pages" src="assets/icons/arrowDropdownOutlined.svg" />
        </div>
        <ul class="dropdown-menu">
          <li class="dropdown-item" *ngFor="let opt of pagesSizeOptions" (click)="changePageSize(opt)">{{ opt }}</li>
        </ul>
      </div>
    </div>
    <div class="range">
      <span class="range-label">{{rangeLabel}} {{pageInfo.items | translate}}</span>
    </div>
  </div>
  <div class="page-controls">
    <button class="page-control" (click)="firstPage()" [disabled]="page == 0" *ngIf="showFirstLastButtons">
      <img src="assets/img/svg/first_page.svg">
    </button>
    <button class="page-control" (click)="previousPage()" [disabled]="page == 0">
      <img src="assets/img/svg/previous_page.svg">
    </button>
    <button class="page-num" *ngFor="let viewPage of viewPages" (click)="selectPage(viewPage)"
      [ngClass]="page==viewPage ? 'selectedPage' : ''">{{viewPage+1}}</button>
    <button class="page-control" (click)="nextPage()" [disabled]="page>=totalPages">
      <img src="assets/img/svg/next_page.svg">
    </button>
    <button class="page-control" (click)="lastPage()" [disabled]="page>=totalPages" *ngIf="showFirstLastButtons">
      <img src="assets/img/svg/last_page.svg">
    </button>
  </div>
</div>
